import { ExistingPagesList } from '../../web/components/PageHelper/Screens/ExistingPages/ExistingPageListing/types';
import { PagePathErrorCodes, PageAdded } from './types';

export enum ActionTypes {
  PAGE_HELPER_OPEN_MODAL = 'PAGE_HELPER_OPEN_MODAL',
  PAGE_HELPER_CLOSE_MODAL = 'PAGE_HELPER_CLOSE_MODAL',
  PAGE_HELPER_SET_MODAL_TITLE = 'PAGE_HELPER_SET_MODAL_TITLE',

  PAGE_HELPER_RENDER_PAGE_TEMPLATES_LISTING = 'PAGE_HELPER_RENDER_PAGE_TEMPLATES_LISTING',
  PAGE_HELPER_RENDER_PREVIEW_TEMPLATE = 'PAGE_HELPER_RENDER_PREVIEW_TEMPLATE',
  PAGE_HELPER_RENDER_USE_PAGE_TEMPLATE_DETAILS = 'PAGE_HELPER_RENDER_USE_PAGE_TEMPLATE_DETAILS',
  PAGE_HELPER_RENDER_EXISTING_PAGES_LISTING = 'PAGE_HELPER_RENDER_EXISTING_PAGES_LISTING',
  PAGE_HELPER_RENDER_COPY_PAGE_DETAILS = 'PAGE_HELPER_RENDER_COPY_PAGE_DETAILS',
  PAGE_HELPER_RENDER_BLANK_PAGE_DETAILS = 'PAGE_HELPER_RENDER_BLANK_PAGE_DETAILS',

  PAGE_HELPER_SET_TEMPLATE_LIST_FILTER_TAG = 'PAGE_HELPER_SET_TEMPLATE_LIST_FILTER_TAG',
  PAGE_HELPER_SET_PAGE_LIST_FILTER_TAG = 'PAGE_HELPER_SET_PAGE_LIST_FILTER_TAG',
  PAGE_HELPER_SET_PAGE_LIST_SEARCH_QUERY = 'PAGE_HELPER_SET_PAGE_LIST_SEARCH_QUERY',

  PAGE_HELPER_SET_PAGES_IN_MODULES = 'PAGE_HELPER_SET_PAGES_IN_MODULES',
  PAGE_HELPER_SET_PAGES_IN_MODULES_LOAD_START = 'PAGE_HELPER_SET_PAGES_IN_MODULES_LOAD_START',
  PAGE_HELPER_SET_PAGES_IN_MODULES_LOAD_ERROR = 'PAGE_HELPER_SET_PAGES_IN_MODULES_LOAD_ERROR',

  PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_NAME = 'PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_NAME',
  PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_TAGS = 'PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_TAGS',
  PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_PATH = 'PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_PATH',

  PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_START = 'PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_START',
  PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_END = 'PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_END',
  PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_FAILED = 'PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_FAILED',

  PAGE_HELPER_ADD_BLANK_PAGE_START = 'PAGE_HELPER_ADD_BLANK_PAGE_START',
  PAGE_HELPER_ADD_BLANK_PAGE_END = 'PAGE_HELPER_ADD_BLANK_PAGE_END',
  PAGE_HELPER_ADD_BLANK_PAGE_FAILED = 'PAGE_HELPER_ADD_BLANK_PAGE_FAILED',

  PAGE_HELPER_COPY_PAGE_START = 'PAGE_HELPER_COPY_PAGE_START',
  PAGE_HELPER_COPY_PAGE_END = 'PAGE_HELPER_COPY_PAGE_END',
  PAGE_HELPER_COPY_PAGE_FAILED = 'PAGE_HELPER_COPY_PAGE_FAILED',

  PAGE_HELPER_LINK_PAGE_START = 'PAGE_HELPER_LINK_PAGE_START',
  PAGE_HELPER_LINK_PAGE_END = 'PAGE_HELPER_LINK_PAGE_END',
  PAGE_HELPER_LINK_PAGE_FAILED = 'PAGE_HELPER_LINK_PAGE_FAILED',

  PAGE_HELPER_CHECK_PAGE_PATH_START = 'PAGE_HELPER_CHECK_PAGE_PATH_START',
  PAGE_HELPER_CHECK_PAGE_PATH_SUCCESS = 'PAGE_HELPER_CHECK_PAGE_PATH_SUCCESS',
  PAGE_HELPER_CHECK_PAGE_PATH_FAILED = 'PAGE_HELPER_CHECK_PAGE_PATH_FAILED',
  PAGE_HELPER_CHECK_PAGE_PATH_EMPTY = 'PAGE_HELPER_CHECK_PAGE_PATH_EMPTY',

  PAGE_HELPER_CONTENT_EDITOR_PAGE_ADDED = 'PAGE_HELPER_CONTENT_EDITOR_PAGE_ADDED',
}

export interface OpenPageHelperForModule {
  type: ActionTypes.PAGE_HELPER_OPEN_MODAL;
  moduleId: string;
}

export interface ClosePageHelperForModule {
  type: ActionTypes.PAGE_HELPER_CLOSE_MODAL;
}

export interface SetPageHelperModalTitle {
  type: ActionTypes.PAGE_HELPER_SET_MODAL_TITLE;
  title: string;
}

export interface RenderPageTemplatesListing {
  type: ActionTypes.PAGE_HELPER_RENDER_PAGE_TEMPLATES_LISTING;
}

export interface RenderPageTemplatePreview {
  type: ActionTypes.PAGE_HELPER_RENDER_PREVIEW_TEMPLATE;
  templateId: string;
  templateName: string;
  templatePreview: string;
}

export interface RenderUsePageTemplateDetails {
  type: ActionTypes.PAGE_HELPER_RENDER_USE_PAGE_TEMPLATE_DETAILS;
  templateId: string;
  pageName: string;
  pagePath: string;
}

export interface RenderExistingPageListing {
  type: ActionTypes.PAGE_HELPER_RENDER_EXISTING_PAGES_LISTING;
}

export interface RenderCopyPageDetails {
  type: ActionTypes.PAGE_HELPER_RENDER_COPY_PAGE_DETAILS;
  pageId: string;
  originalPageName: string;
  pageName: string;
  pagePath: string;
  pageTags: string[];
}

export interface RenderBlankPageDetails {
  type: ActionTypes.PAGE_HELPER_RENDER_BLANK_PAGE_DETAILS;
}

export interface SetSelectedActivityTag {
  type: ActionTypes.PAGE_HELPER_SET_TEMPLATE_LIST_FILTER_TAG;
  templateTag: string;
}

export interface SetPageListFilterTag {
  type: ActionTypes.PAGE_HELPER_SET_PAGE_LIST_FILTER_TAG;
  pageTag: string;
}

export interface SetPageListSearchQuery {
  type: ActionTypes.PAGE_HELPER_SET_PAGE_LIST_SEARCH_QUERY;
  searchQuery: string;
}

export interface SetPagesInModules {
  type: ActionTypes.PAGE_HELPER_SET_PAGES_IN_MODULES;
  pages: ExistingPagesList;
}

export interface PagesInModulesLoad {
  type: ActionTypes.PAGE_HELPER_SET_PAGES_IN_MODULES_LOAD_START;
}

export interface PageTemplatesError {
  type: ActionTypes.PAGE_HELPER_SET_PAGES_IN_MODULES_LOAD_ERROR;
  error: string;
}

export interface SetPageConfigurationPageName {
  type: ActionTypes.PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_NAME;
  pageName: string;
}

export interface SetPageConfigurationPageTags {
  type: ActionTypes.PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_TAGS;
  pageTags: string[];
}

export interface SetPageConfigurationPagePath {
  type: ActionTypes.PAGE_HELPER_SET_PAGE_CONFIGURATION_PAGE_PATH;
  pagePath: string;
}

export interface AddPageWithTemplateStart {
  type: ActionTypes.PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_START;
  templateId: string;
  templateName: string;
}

export interface AddPageWithTemplateEnd {
  type: ActionTypes.PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_END;
  lastAddedPage: PageAdded;
}

export interface AddPageWithTemplateFailed {
  type: ActionTypes.PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_FAILED;
  error: string;
}

export interface AddBlankPageStart {
  type: ActionTypes.PAGE_HELPER_ADD_BLANK_PAGE_START;
}

export interface AddBlankPageEnd {
  type: ActionTypes.PAGE_HELPER_ADD_BLANK_PAGE_END;
  lastAddedPage: PageAdded;
}

export interface AddBlankPageFailed {
  type: ActionTypes.PAGE_HELPER_ADD_BLANK_PAGE_FAILED;
  error: string;
}

export interface CopyPageStart {
  type: ActionTypes.PAGE_HELPER_COPY_PAGE_START;
}

export interface CopyPageEnd {
  type: ActionTypes.PAGE_HELPER_COPY_PAGE_END;
  lastAddedPage: PageAdded;
}

export interface CopyPageFailed {
  type: ActionTypes.PAGE_HELPER_COPY_PAGE_FAILED;
  error: string;
}

export interface LinkPageStart {
  type: ActionTypes.PAGE_HELPER_LINK_PAGE_START;
}

export interface LinkPageEnd {
  type: ActionTypes.PAGE_HELPER_LINK_PAGE_END;
  lastAddedPage: PageAdded;
}

export interface LinkPageFailed {
  type: ActionTypes.PAGE_HELPER_LINK_PAGE_FAILED;
  error: string;
}

export interface checkPagePathStart {
  type: ActionTypes.PAGE_HELPER_CHECK_PAGE_PATH_START;
  pagePath: string | null;
}

export interface checkPagePathSuccess {
  type: ActionTypes.PAGE_HELPER_CHECK_PAGE_PATH_SUCCESS;
  canUse: boolean;
  errorCode: PagePathErrorCodes | null;
}

export interface checkPagePathFailed {
  type: ActionTypes.PAGE_HELPER_CHECK_PAGE_PATH_FAILED;
}

export interface checkPagePathEmpty {
  type: ActionTypes.PAGE_HELPER_CHECK_PAGE_PATH_EMPTY;
}

export interface pageHelperContentEditorPageAdded {
  type: ActionTypes.PAGE_HELPER_CONTENT_EDITOR_PAGE_ADDED;
  pageAdded: PageAdded;
}

export type PageHelperAction =
  | OpenPageHelperForModule
  | ClosePageHelperForModule
  | SetPageHelperModalTitle
  | RenderPageTemplatesListing
  | RenderPageTemplatePreview
  | RenderUsePageTemplateDetails
  | RenderExistingPageListing
  | RenderCopyPageDetails
  | RenderBlankPageDetails
  | SetSelectedActivityTag
  | SetPageListFilterTag
  | SetPageListSearchQuery
  | SetPagesInModules
  | PagesInModulesLoad
  | PageTemplatesError
  | SetPageConfigurationPageName
  | SetPageConfigurationPageTags
  | SetPageConfigurationPagePath
  | AddPageWithTemplateStart
  | AddPageWithTemplateEnd
  | AddPageWithTemplateFailed
  | checkPagePathStart
  | checkPagePathSuccess
  | checkPagePathFailed
  | checkPagePathEmpty
  | pageHelperContentEditorPageAdded
  | AddBlankPageStart
  | AddBlankPageEnd
  | AddBlankPageFailed
  | CopyPageStart
  | CopyPageEnd
  | CopyPageFailed
  | LinkPageStart
  | LinkPageEnd
  | LinkPageFailed;
